import React from "react";
import loader from "../assets/img/page-loader.gif";
import logo from "../assets/img/logo.png";

const PageLoader = () => {
  return (
    <div className="page-loader">
        <div className="text-center">
            <img src={logo} alt="logo" style={{ width: '200px' }}  ></img> <br />
            <img src={loader} alt="Loader" style={{ width: '100px' }} ></img>
          </div>
    </div>
  );
};

export default PageLoader;
